import {Component, OnInit} from '@angular/core';
import {LocalStorageService} from '../../services/local-storage.service';
import {ActivatedRoute} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LoginModalComponent} from '../login-modal/login-modal.component';
import {LanguageService} from '../../services/language.service';
import {User} from '../../classes/User';
import {UserService} from '../../services/user/user.service';

@Component({
  selector: 'app-navigation',
  styleUrls: ['./navigation.component.scss'],
  templateUrl: './navigation.component.html',
})
export class NavigationComponent implements OnInit {

  public logoLink = '/assets/img/qh-logo_dark.png';
  public isPageScrolled = false;
  public isMenuCollapsed = true;

  public isLoggedIn = false;
  public isAdmin = false;
  public isSuperAdmin = false;
  public isBarista = false;

  private roles: string[];
  private tokens: number;

  private currentUser: User;

  public username: string;
  public langs: Array<string>;

  constructor(private localStorageService: LocalStorageService,
              private activatedRoute: ActivatedRoute,
              private modalService: NgbModal,
              public languageService: LanguageService,
              private userService: UserService) {

    languageService.initiate();
  }

  public ngOnInit(): void {
    this.isLoggedIn = !!this.localStorageService.getToken();

    if (this.isLoggedIn) {
      const user = this.localStorageService.getUser();
      this.roles = user.roles;
      this.isAdmin = this.roles.includes('ROLE_ADMIN');              // TODO add to enum
      this.isSuperAdmin = this.roles.includes('ROLE_SUPER_ADMIN'); // TODO add to enum
      this.isBarista = this.roles.includes('ROLE_BARISTA');

      this.tokens = user.tokens;
      this.username = user.name + '(' + user.tokens + ')';
    }
  }

  public logout(): void {
    this.localStorageService.signOut();
    window.location.reload();
  }

  openModal(type: string): void {
    const modalRef = this.modalService.open(LoginModalComponent,
      {
        scrollable: true,
        windowClass: 'modal-login',
        size: 'lg',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    modalRef.componentInstance.type = type;
    modalRef.result.then((result) => {
    }, (reason) => {
    });
  }

  switchLanguage(): void {
    this.languageService.switchLanguage(this.languageService.getLangNameToSwitch(false));
  }
}
